module.exports = __webpack_public_path__ + "img/home_host_tag.d0789f24.png";